import React from "react";
import {Container, makeStyles} from "@material-ui/core";
import {Notifications} from '../components/ui/notification/Notification';
import {NotificationProvider} from "../components/ui/notification/NotificationProvider";

const useStyles = makeStyles(theme => ({
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        width: '100%'
    },
    container: {
    }
}));


export const MainContainer: React.FC = ({children}) => {
    const classes = useStyles();

    return (
        <NotificationProvider>
            {<main className={classes.content}>
                <div className={classes.appBarSpacer}/>
                <Container className={classes.container}>
                    <Notifications/>
                    {children || ''}
                </Container>
            </main>
            }
        </NotificationProvider>
    )
};
